import React, { Component } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';

export class ContactSection extends Component {
  static displayName = ContactSection.name;

  render() {
    return (
      <section id="contact" className="section" style={{ backgroundColor: 'var(--light-cream)' }}>
        <Container>
          <h2 className="section-title">Contáctanos</h2>
          <Row>
            <Col lg="8" className="mx-auto">
              <Card className="p-4">
                <Row>
                  <Col md="6">
                    <h4 style={{ color: 'var(--dark-blue)' }} className="mb-4">
                      Información de Contacto
                    </h4>
                    <div className="mb-3">
                      <i className="fas fa-map-marker-alt me-3" style={{ color: 'var(--primary-blue)' }}></i>
                      <strong>Dirección:</strong><br />
                      <span className="ms-4">
                        Cra 4 # 11A-38 Rodadero,<br />
                        Magdalena, Colombia
                      </span>
                    </div>
                    <div className="mb-3">
                      <i className="fas fa-clock me-3" style={{ color: 'var(--secondary-gold)' }}></i>
                      <strong>Horarios de Atención:</strong><br />
                      <span className="ms-4">
                        Martes a Viernes: 8:00 AM - 6:00 PM<br />
                        Sábados: 8:00 AM - 2:00 PM
                      </span>
                    </div>
                    <div className="mb-3">
                      <i className="fas fa-phone me-3" style={{ color: 'var(--accent-blue)' }}></i>
                      <strong>Teléfono:</strong><br />
                      <span className="ms-4">(5) 4394538</span>
                    </div>
                    <div className="mb-3">
                      <i className="fas fa-mobile-alt me-3" style={{ color: 'var(--accent-blue)' }}></i>
                      <strong>Celular:</strong><br />
                      <span className="ms-4">(57) 302 3772270</span>
                    </div>
                    <div className="mb-3">
                      <i className="fas fa-envelope me-3" style={{ color: 'var(--primary-blue)' }}></i>
                      <strong>Email:</strong><br />
                      <span className="ms-4">info@iglesiacbr.org</span>
                    </div>
                  </Col>
                  <Col md="6">
                    <h4 style={{ color: 'var(--dark-blue)' }} className="mb-4">
                      Envíanos un Mensaje
                    </h4>
                    <form>
                      <div className="mb-3">
                        <input 
                          type="text" 
                          className="form-control" 
                          placeholder="Tu nombre"
                          style={{ borderRadius: '25px', border: '2px solid var(--light-cream)' }}
                        />
                      </div>
                      <div className="mb-3">
                        <input 
                          type="email" 
                          className="form-control" 
                          placeholder="Tu email"
                          style={{ borderRadius: '25px', border: '2px solid var(--light-cream)' }}
                        />
                      </div>
                      <div className="mb-3">
                        <textarea 
                          className="form-control" 
                          rows="4" 
                          placeholder="Tu mensaje"
                          style={{ borderRadius: '15px', border: '2px solid var(--light-cream)' }}
                        ></textarea>
                      </div>
                      <Button 
                        color="primary" 
                        className="w-100"
                        style={{ borderRadius: '25px' }}
                      >
                        Enviar Mensaje
                      </Button>
                    </form>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
